import { Routes } from '@angular/router';

import { fertigationDashboardRoutes } from './components/fertigation-dashboard/fertigation-dashboard.routes';
import { tgaOnionDashboardRoutes } from './components/tga-onion-dashboard/tga-onion-dashboard.routes';
import { tgaPotatoSeedStarchDashboardRoutes } from './components/tga-potato-seed-starch-dashboard/tga-potato-seed-starch-dashboard.routes';
import { virusDashboardRoutes } from './components/virus-dashboard/virus-dashboard.routes';

export const powerBiDashboardsRoutes: Routes = [
  ...virusDashboardRoutes,
  ...fertigationDashboardRoutes,
  ...tgaPotatoSeedStarchDashboardRoutes,
  ...tgaOnionDashboardRoutes,
];
